import * as React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { siteTitle } from "../../../settings";
import { Button } from "react-bootstrap";

export const Home: React.FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>
                    {t("Welcome")} | {siteTitle}
                </title>
            </Helmet>

            <h1>{t("Welcome")}</h1>
            <p>
                {t("Welcome to the site dedicated to computer games.")}{" "}
                {t("These pages aim to introduce you to games from the past.")} {t("They currently contain games for")}{" "}
                {t("8-bit computer")}
                <strong>
                    {" "}
                    <a href={"https://en.wikipedia.org/wiki/ZX_Spectrum"} target={"_blank"} rel={"noreferrer"}>
                        ZX Spectrum
                    </a>
                </strong>
                {", "}
                <strong>
                    {" "}
                    <a href={"https://en.wikipedia.org/wiki/Commodore_64"} target={"_blank"} rel={"noreferrer"}>
                        Commodore 64
                    </a>
                </strong>
                {", "}
                {t("16-bit computer")}
                <strong>
                    {" "}
                    <a href={"https://en.wikipedia.org/wiki/Amiga"} target={"_blank"} rel={"noreferrer"}>
                        Amiga
                    </a>
                </strong>
                {", "}
                {t("32-bit computer")}
                <strong>
                    {" "}
                    <a
                        href={"https://en.wikipedia.org/wiki/IBM_Personal_Computer"}
                        target={"_blank"}
                        rel={"noreferrer"}
                    >
                        (IBM) PC
                    </a>
                </strong>
                {", "}
                <strong>{t("new generation personal computers")} </strong>
                {t("and arcade emulator")}
                <strong>
                    {" "}
                    <a href={"https://en.wikipedia.org/wiki/MAME"} target={"_blank"} rel={"noreferrer"}>
                        MAME
                    </a>
                </strong>
                .
            </p>
            <p>
                {t("Everyone likes to play.")}{" "}
                {t(
                    "If you also played computer games in your childhood, I will be happy if you reminisce about your childhood together with me and my pages."
                )}{" "}
                {t(
                    "And if you are younger, I will be happy if you also use my pages to learn something about how we used to play, especially in the 90s of the last century."
                )}
            </p>
            <p>
                {t("I wish you pleasant memories and")}{" "}
                <NavLink to={"/games"}>
                    <strong>{t("browsing the pages")}</strong>
                </NavLink>
                .
            </p>
            <p className={"text-center"}>
                <NavLink to={"/games"}>
                    <Button>
                        <span>{t("Browse pages")}</span>
                    </Button>
                </NavLink>
            </p>
            <hr />
            <p>
                {t(
                    "Some of the materials from ZX Spectrum section was used with kind permission of the author of server"
                )}
                <strong>
                    {" "}
                    <a href={"https://www.zx-spectrum.cz/"} target={"_blank"} rel={"noreferrer"}>
                        ZX-Spectrum Games
                    </a>
                </strong>
                .
            </p>
        </>
    );
};
